import React from 'react'

import Markdown from '../../markdown'
import * as Types from '../../types'

const article: Types.Article = {
  title: 'GRSLY: SRS for language learning beyond vocab.',
  url: 'grsly',
  date: new Date('Jul 28 2025').getTime(),
  feedContent: (
    <Markdown>{`
![(1.6)](media/2025-7-28-HSRS/sc.jpg)

_TLDR: New grammar examples for every review so you internalize patterns, not sentences. Works alongside spaced-repetition/immersion, not against it. Import from anki, [try it](https://grsly.com/)_

## State of the art

**Linear resources** (Duo, Rosetta, textbooks) provide a well defined learning structure, but struggle with long-term retention and flexibility. Being static by nature, they often repeat content too often or too little for an individual learner.

**Spaced-repetition systems** (Anki, SuperMemo, etc. [read about them](https://ncase.me/remember/)) determine when you need to review content _dynamically_, based on repeated assessment. While effective, they only work for learning _discrete chunks of information_. With grammar, you end up memorizing individual examples or explanations. This leads to [rote learning](https://www.reddit.com/r/languagelearning/comments/7adze0/musings_after_15_years_of_language_learning_and) where the learner can indeed reproduce the example(s), _but will often fail to generalize the underlying concepts and [apply them elsewhere](https://www.reddit.com/r/Anki/comments/18ii5c6/a_conceptual_problem_with_using_anki_with)!_

**"Immersion"** (using the language in real life in one way or another) in the end is the only truly effective method, but is incredibly difficult. Unless deeply committed, or forced, most people struggle. We're all looking for ways to make this easier.

## The proposal

The idea is to break a key assumption of spaced-repetition systems: _that a card's content must never change._ I propose a new category of "recipe cards" that can create many different examples using other cards as ingredients.
`}</Markdown>
  ),
  tags: [],
  loadContent: () => import('./content'),
}

export default article
